// extracted by mini-css-extract-plugin
export var actionText = "_og-4";
export var container = "_og-0";
export var leftSection = "_og-1";
export var rightSection = "_og-2";
export var settingsButton = "_og-6";
export var settingsIcon = "_og-7";
export var shortcut = "_og-5";
export var shortcutGroup = "_og-3";